// AseHealthPanel.jsx — status ASE Health Check (backend/aseHealthCheck.js).
// Ditampilkan di Table Maintenance → Sybase DR, di atas Sybase DR Monitor.
import React, { useEffect, useState, useCallback } from 'react';

const sysOf = (i) => (i === 'HOST:10.32.18.30' || /^D/.test(i)) ? 'DEV' : (i === 'HOST:10.32.18.20' || /^Q/.test(i)) ? 'QAS' : '';
const COLORS = { OK: '#16a34a', WARN: '#d97706', CRIT: '#dc2626' };

export default function AseHealthPanel({ api, CronScheduler }) {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const load = useCallback(async () => {
    try { const d = await api('/api/ase-health/state'); setRows(Array.isArray(d) ? [...d].sort((a, b) => (sysOf(a.item) + (a.item.startsWith('HOST') ? 'Z' : a.item)).localeCompare(sysOf(b.item) + (b.item.startsWith('HOST') ? 'Z' : b.item))) : []); setErr(''); }
    catch (e) { setErr(e.message || String(e)); }
  }, [api]);

  useEffect(() => { load(); const id = setInterval(load, 60000); return () => clearInterval(id); }, [load]);

  const runNow = async () => {
    setBusy(true);
    try { await api('/api/ase-health/run', { method: 'POST', body: '{}' }); await load(); }
    catch (e) { setErr(e.message || String(e)); }
    setBusy(false);
  };

  return (
    <div style={{ border: '1px solid #e2e8f0', borderRadius: 10, padding: 14, marginBottom: 20, background: '#fff' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 4 }}>
        <span style={{ fontSize: 15, fontWeight: 700, color: '#0f172a' }}>🩺 ASE Health Check — SAP DEV &amp; QAS</span>
        <button onClick={runNow} disabled={busy}
          style={{ marginLeft: 'auto', fontSize: 12, padding: '4px 10px', borderRadius: 6, border: '1px solid #cbd5e1', background: '#f8fafc', cursor: 'pointer' }}>
          {busy ? 'Checking…' : 'Check now'}
        </button>
      </div>
      <p style={{ fontSize: 12, color: '#64748b', marginTop: 0 }}>
        Every 5 minutes: new-login test (R3trans -d), CLOSE_WAIT on the ASE port, errorlog (infected / timeslice /
        cache too small / 1105), dataserver process, host swap &amp; free RAM. Alerts go to the Sybase DR Telegram bot
        and email on status change, with a reminder every 60 minutes while a problem persists.
      </p>
      {err && <div style={{ color: '#dc2626', fontSize: 12, marginBottom: 8 }}>{err}</div>}
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
        <thead>
          <tr style={{ background: '#f1f5f9', textAlign: 'left' }}>
            <th style={{ padding: 6 }}>System</th><th style={{ padding: 6 }}>Item</th><th style={{ padding: 6 }}>Status</th>
            <th style={{ padding: 6 }}>Detail</th><th style={{ padding: 6 }}>Last check (UTC)</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={5} style={{ padding: 8, color: '#94a3b8' }}>No data yet.</td></tr>}
          {rows.map(r => (
            <tr key={r.item} style={{ borderTop: '1px solid #e2e8f0' }}>
              <td style={{ padding: 6, color: '#475569' }}>{sysOf(r.item)}</td>
              <td style={{ padding: 6, fontWeight: 600 }}>{r.item.startsWith('HOST:') ? `Host ${r.item.slice(5)}` : `ASE ${r.item}`}</td>
              <td style={{ padding: 6 }}>
                <span style={{ color: '#fff', background: COLORS[r.status] || '#64748b', borderRadius: 4, padding: '2px 8px', fontWeight: 700 }}>{r.status}</span>
              </td>
              <td style={{ padding: 6, whiteSpace: 'pre-wrap', fontFamily: 'monospace', color: '#334155' }}>{r.detail || '—'}</td>
              <td style={{ padding: 6, color: '#64748b' }}>{r.updated_at}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {CronScheduler && <div style={{ marginTop: 10 }}><CronScheduler api={api} jobKey="ase_health_check" runConfirm="Run ASE Health Check now?" /></div>}
    </div>
  );
}
